export const getChildEntries = (parent) =>
    (parent?.["@nodes"] || []).map((name) => ({ name, node: parent[name] })).filter(({ node }) => node);

export const getChildNodes = (parent) => getChildEntries(parent).map(({ node }) => node);

export const getFirstChild = (parent) => getChildNodes(parent)[0] ?? null;
